import ReactGA from 'react-ga';
import MentalApi from './MentalApi';

const TRACKER_NAMES = ['gtag_UA_115367782_1'];

export default class AnalyticsHelper {
    private static isAllowed(): boolean {
        // @ts-ignore
        return Boolean(window.ga);

        // return Boolean(typeof gtag === 'function');
    }

    // private static gtagEvent(eventName: string, data: any) {
    //     if (!AnalyticsHelper.isAllowed()) return;

    //     /* eslint-disable */
    //     // @ts-ignore
    //     gtag('event', eventName, data);
    //     /* eslint-enable */
    // }

    // private static gtagSet(data: any) {
    //     if (!AnalyticsHelper.isAllowed()) return;

    //     /* eslint-disable */
    //     // @ts-ignore
    //     gtag('set', data);
    //     /* eslint-enable */
    // }

    private static updateLevels() {
        const userData = MentalApi.getUserData();

        const levelString = userData
            ? userData.levels.join(',')
            : '';

        ReactGA.set({ dimension1: levelString }, TRACKER_NAMES);
    }

    static trackPageView(path: string) {
        if (!AnalyticsHelper.isAllowed()) return;

        AnalyticsHelper.updateLevels();
        ReactGA.pageview(path, TRACKER_NAMES);
    }

    static trackOpenPlayerEvent(lessonTitle: string) {
        if (!AnalyticsHelper.isAllowed()) return;

        ReactGA.event({ category: 'Übungen', action: 'Player öffnen', label: lessonTitle },
            TRACKER_NAMES);
    }

    static trackPlayEvent(lessonTitle: string) {
        if (!AnalyticsHelper.isAllowed()) return;

        ReactGA.event({ category: 'Übungen', action: 'Play', label: lessonTitle },
            TRACKER_NAMES);
    }
}
